import { api } from '@/store/api'
import type { Instruction } from '@/features/instructions/types'
import type { PaginatedResponse, GamifiedCourseListItem } from './types'

interface CourseListParams {
  page?: number
  limit?: number
  isPublished?: boolean
  createdAfter?: string
  updatedAfter?: string
}

interface InstructionListParams {
  page?: number
  limit?: number
  accessType?: 'public' | 'link' | 'private'
  createdAfter?: string
  updatedAfter?: string
}

const buildParams = <T extends object>(params: T) => {
  const out: Record<string, string | number | boolean> = {}
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null) out[k] = v as string | number | boolean
  }
  return out
}

export const adminApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMyCourses: build.query<PaginatedResponse<GamifiedCourseListItem>, CourseListParams>({
      query: (params) => ({
        url: 'gamified-courses/my',
        params: buildParams(params),
      }),
    }),
    getAllCourses: build.query<PaginatedResponse<GamifiedCourseListItem>, CourseListParams>({
      query: (params) => ({
        url: 'gamified-courses/all',
        params: buildParams(params),
      }),
    }),
    getAllInstructions: build.query<PaginatedResponse<Instruction>, InstructionListParams>({
      query: (params) => ({
        url: 'instructions/admin/all',
        params: buildParams(params),
      }),
    }),
  }),
})

export const { useGetMyCoursesQuery, useGetAllCoursesQuery, useGetAllInstructionsQuery } = adminApi
